export default __webpack_public_path__ + "assets/img/znak.58baffdefb353aec6b614f0046ca505b.png";